import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { TrueNorthPortraitCardStackContentViewModel } from './true-north-portrait-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../../shared/print-card-content.component';

@Component({
  selector: 'app-true-north-portrait-card-stack-content',
  templateUrl: './true-north-portrait-card-stack-content.component.html',
  styleUrls: ['./true-north-portrait-card-stack-content.component.scss'],
  providers: [TrueNorthPortraitCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TrueNorthPortraitCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: TrueNorthPortraitCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
